import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ui-colors',
  templateUrl: './ui-colors.component.html',
  styleUrls: ['./ui-colors.component.scss']
})
export class UiColorsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
